import { AccountConfigNonStandardProperties } from "./reducers/environments";

/**
 * KEEP THESE SORTED ALPHABETICALLY.
 */
type FeatureFlag =
  | "adBlock"
  | "adPerformanceMeta"
  | "allowJsDynamicProp"
  | "analytics"
  | "appointmentStageMapping"
  | "audienceEmailFromUserProperty"
  | "audienceSegmentationUserProperties"
  | "audiences"
  | "audiencesIngest"
  | "botBlocking"
  | "cdaDashboard"
  | "chatSupport"
  | "claudeOrchestrator"
  | "contractAllowsAIUsage"
  | "dataConnectors"
  | "dataSharingAgreement"
  | "disableMasqueradeWarningBanner"
  | "destinationValidationChat"
  | "displayNewEventLibraryPage"
  | "emitAppointmentAttributionEvents"
  | "emitAppointmentAttributionEventsMeta"
  | "eventIdentitySupport"
  | "freshpaintAiChat"
  | "freshpaintAiDev"
  | "freshpaintConsentManagementUI"
  | "frictionSignals"
  | "functions"
  | "googleAdsEnhancedConversionsPassthrough"
  | "googleDataManagerConversionApi"
  | "groupByBusinessDimension"
  | "hipaaV2"
  | "identityMatching"
  | "identityMergeSimulator"
  | "insightsSeasonality"
  | "marketingPerformanceAnalysis"
  | "networkEventDefs"
  | "phoneNumberAudiences"
  | "podscribe"
  | "precisionEventsDefaultNotSegmentCompatible"
  | "rbac"
  | "selfServeAuditLog"
  | "serviceAccounts"
  | "sessionReplayCardViewEnabled"
  | "sessionReplayHideLowEngagement"
  | "sessionReplayRecordingPaused"
  | "sourceFunctions"
  | "sqlTransformations"
  | "sqlTransformationsv2"
  | "tempAudiencesNoOverview"
  | "tempNewUploader"
  | "tempSegmentsDetailV2"
  | "tempSegmentsM1"
  | "traces"
  | "translation"
  | "unifiedDestinationsUI"
  | "useUnifiedEntryScript"
  | "webTrackerMonitoring"
  | "webTrackerMonitoringM3"
  | "webTrackerMonitoringTrackerBlockedUI"
  | "webTrackerMonitoringWtm2";

export type FlagGetter = (featureName: FeatureFlag) => boolean;

/**
 * Get the value of a feature flag
 */
interface FeatureFlagConfigurationLocation {
  config: Partial<
    Record<FeatureFlag, boolean> & AccountConfigNonStandardProperties
  >;
}
export function getFeature(
  accountMetadata: FeatureFlagConfigurationLocation,
  featureFlag: FeatureFlag,
): boolean {
  switch (featureFlag) {
    case "adBlock":
    case "adPerformanceMeta":
    case "allowJsDynamicProp":
    case "analytics":
    case "appointmentStageMapping":
    case "audiences":
    case "audiencesIngest":
    case "audienceEmailFromUserProperty":
    case "audienceSegmentationUserProperties":
    case "botBlocking":
    case "cdaDashboard":
    case "chatSupport":
    case "claudeOrchestrator":
    case "contractAllowsAIUsage":
    case "dataConnectors":
    case "dataSharingAgreement":
    case "disableMasqueradeWarningBanner":
    case "destinationValidationChat":
    case "displayNewEventLibraryPage":
    case "emitAppointmentAttributionEvents":
    case "emitAppointmentAttributionEventsMeta":
    case "freshpaintAiChat":
    case "freshpaintAiDev":
    case "freshpaintConsentManagementUI":
    case "frictionSignals":
    case "functions":
    case "googleAdsEnhancedConversionsPassthrough":
    case "googleDataManagerConversionApi":
    case "groupByBusinessDimension":
    case "hipaaV2":
    case "identityMatching":
    case "identityMergeSimulator":
    case "insightsSeasonality":
    case "marketingPerformanceAnalysis":
    case "eventIdentitySupport":
    case "networkEventDefs":
    case "phoneNumberAudiences":
    case "podscribe":
    case "precisionEventsDefaultNotSegmentCompatible":
    case "rbac":
    case "selfServeAuditLog":
    case "serviceAccounts":
    case "sessionReplayCardViewEnabled":
    case "sessionReplayHideLowEngagement":
    case "sessionReplayRecordingPaused":
    case "sourceFunctions":
    case "sqlTransformations":
    case "sqlTransformationsv2":
    case "tempAudiencesNoOverview":
    case "tempNewUploader":
    case "tempSegmentsDetailV2":
    case "tempSegmentsM1":
    case "traces":
    case "translation":
    case "unifiedDestinationsUI":
    case "useUnifiedEntryScript":
    case "webTrackerMonitoring":
    case "webTrackerMonitoringM3":
    case "webTrackerMonitoringTrackerBlockedUI":
    case "webTrackerMonitoringWtm2":
      return accountMetadata.config[featureFlag] || false;
    default:
      console.warn("Unsupported feature %s requested", featureFlag);
      return false;
  }
}

export default FeatureFlag;
